import React, {Fragment} from 'react'
import { isEmpty } from 'lodash'
import EmptyTableImage from 'images/playbook-report/empty-clickmap.svg'
import { Div, Span } from '@driftt/tide-core'

import './style.css'

const ClickMap = ({ clickMapData }) => {
  return (
    <Div className="clickmap-wrapper">
        <Div className="clickmap-table">
          <Div className="clickmap-header">
            <Span className="clickmap-image">BANNER</Span>
            <Span className="clickmap-number">VIEWS</Span>
            <Span className="clickmap-number">CLICKS</Span>
          </Div>
          {!isEmpty(clickMapData) ? clickMapData.map(click => {
            return <Fragment>
                <Div className="clickmap-row">
                      <Span className="clickmap-image"> <img src={click.campaignGraphic} alt="let's go"/></Span>
                      <Span className="clickmap-number">{click.views || 0}</Span>
                      <Span className="clickmap-number">
                        <Div>
                          {click.clicks || 0}
                          <Span className="clickmap-percentage">{(click.views && click.clicks) ? `${Math.min(click.clicks / click.views * 100, 100)}%` : `0%`}</Span>
                        </Div>
                      </Span>
                    </Div>
                  <hr/>
                </Fragment>
          }) :
           <Div className="clickmap-empty-state">
            <img src={EmptyTableImage} alt="no clickmap data found"/>
            <b>There is no click data to display for this timeframe</b>
           </Div>
          }
        </Div>
    </Div>
  )
}

export default ClickMap
